@if (billAccountOptions.length > 0) {
  <div class="column twelve" [formGroup]="parentFormGroup" data-cy="billAccountCheckBoxGroup">
    @for (billAccountOption of billAccountOptions; track billAccountOption; let i = $index) {
      <div [attr.data-cy]="billAccountOption.id" class="margin-top-30">
        <!-- Bill account nickname with checkbox -->
        <div class="account-box">
          <!-- policy risk icons, risks and status pill -->
          <div class="risk-pill">
            <div class="flex">
              <div
                (click)="checkBoxClick(checkBoxOption.at(i), billAccountOption)"
                [style]="billAccountOptions.length === 1 ? 'display: none' : ''"
              >
                <input
                  [formArrayName]="controlName"
                  [value]="checkBoxOption.at(i).value"
                  [disabled]="checkBoxOption.at(i).disabled"
                  [attr.aria-label]="billAccountOption.riskDescription"
                  class="checkbox"
                  type="checkbox"
                  [checked]="checkBoxOption.at(i).value"
                  [style]="billAccountOptions.length === 1 ? 'display: none' : ''"
                />
                <div class="checkbox-label"></div>
              </div>
              <div
                class="risks-width"
                [ngClass]="{ flex: romeFeaturePill && hasMultiBillAccForRome }"
              >
                @if (billAccountOption.linkedAccountIcon && !billAccountOption.icon) {
                  <i class="icon" [ngClass]="billAccountOption.linkedAccountIcon"></i>
                }
                @if (billAccountOption.policyRiskIconList.length) {
                  <ds-bill-account-policy-risk-icon
                    [policyRiskIcons]="billAccountOption.policyRiskIconList"
                  ></ds-bill-account-policy-risk-icon>
                }
                @if (billAccountOption.policyRiskIconList.length === 0) {
                  <ds-bill-account-policy-risk-icon
                    [policyRiskIcons]="[billAccountOption.icon]"
                  ></ds-bill-account-policy-risk-icon>
                }
                @if (romeFeaturePill && hasMultiBillAccForRome && billAccountOption.isRomeNew) {
                  <p
                    class="simplified-pill-text simplified-color-alert"
                    dsContent
                    [contentPath]="'billing.newBillingAccount'"
                  ></p>
                }
                @if (romeFeaturePill && hasMultiBillAccForRome && billAccountOption.isRomeOld) {
                  <p
                    class="simplified-pill-text simplified-color-success"
                    dsContent
                    [contentPath]="'billing.oldBillingAccount'"
                  ></p>
                }
                @if (!billAccountOption.isRomeNew && !billAccountOption.isRomeOld) {
                  <p
                    class="web-view"
                    data-cy="billAccountRiskDescription"
                    [innerHTML]="billAccountOption.riskDescription.replace(regex, '\<br>')"
                  ></p>
                }
              </div>
              <div class="flex pill-width justify-flex-end" data-cy="billAccountRiskDescription">
                <ds-billing-status-pill
                  [statusText]="billAccountOption.pillStatus?.statusText"
                ></ds-billing-status-pill>
              </div>
            </div>
            @if (billAccountOption.isRomeNew || billAccountOption.isRomeOld) {
              <p
                class="web-view"
                data-cy="billAccountRiskDescription"
                [innerHTML]="billAccountOption.riskDescription.replace(regex, '\<br>')"
              ></p>
            }
            <p
              class="mobile-web-view"
              data-cy="billAccountRiskDescription"
              [innerHTML]="billAccountOption.riskDescription.replace(regex, '\<br>')"
            ></p>
          </div>
          <!-- Payment options as radio buttons -->
          <div class="payment-box">
            <div class="options-box">
              @for (paymentOption of billAccountOption.paymentOptions; track paymentOption) {
                <div class="divider">
                  <div
                    [formGroupName]="billAccountOption.id"
                    class="radio-button"
                    (click)="radioButtonClick(paymentOption, billAccountOption)"
                    [ngClass]="{
                      radiodisabled:
                        parentFormGroup.controls[billAccountOption.id].get('paymentOptions')
                          .disabled,
                      errorOutline:
                        parentFormGroup.controls[billAccountOption.id].get('otherAmount').errors &&
                        paymentOption.id === 'otherAmount'
                    }"
                  >
                    <div class="flex items-center">
                      <input
                        formControlName="paymentOptions"
                        [value]="paymentOption"
                        id="{{ paymentOption.id }}"
                        data-cy="radioButtonOption"
                        class="margin-right-16"
                        type="radio"
                        tabindex="0"
                        [attr.aria-label]="paymentOption.amount + paymentOption.text"
                        [checked]="
                          paymentOption.id ===
                          parentFormGroup.controls[billAccountOption.id].get('paymentOptions').value
                            .id
                        "
                        [disabled]="
                          parentFormGroup.get(billAccountOption.id).get('paymentOptions').disabled
                        "
                        (blur)="textBoxChangeEvent(null, paymentOption, billAccountOption)"
                      />
                      @if (paymentOption.id !== 'otherAmount') {
                        <label
                          for="{{ billAccountOption.id }}"
                          data-cy="paymentOptionAmount"
                          class="mb-2"
                          >{{ paymentOption.amount }}
                        </label>
                      }
                      @if (paymentOption.id === 'otherAmount') {
                        <label for="{{ billAccountOption.id }}">
                          <input
                            formControlName="otherAmount"
                            type="text"
                            tabindex="0"
                            [attr.aria-label]="paymentOption.amount"
                            inputmode="numeric"
                            maxlength="8"
                            [value]="paymentOption.amount"
                            data-cy="otherAmountOption"
                            class="other-amount"
                            [disabled]="
                              parentFormGroup.controls[billAccountOption.id].get('paymentOptions')
                                .disabled
                            "
                            (click)="textBoxClick($event)"
                            (blur)="textBoxChangeEvent($event, paymentOption, billAccountOption)"
                          />
                        </label>
                      }
                    </div>
                    <div class="flex min-due-text">
                      <div class="column mb-2" data-cy="paymentOptionText">
                        {{ paymentOption.text }}
                      </div>
                    </div>
                    <div class="flex min-due-text">
                      <div>
                        @if (
                          paymentOption.id === 'minDue' &&
                          billAccountOption.pillStatus?.statusSubText
                        ) {
                          <div
                            [ngClass]="
                              billAccountOption.pillStatus?.statusText
                                .toLowerCase()
                                .replace(' ', '')
                            "
                          >
                            {{ billAccountOption.pillStatus?.statusSubText }}
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              }
              <!-- Radio field error message -->
              @if (parentFormGroup.controls[billAccountOption.id].get('otherAmount').errors) {
                <div class="error flex">
                  <span class="icon-alert"></span>
                  <span
                    tabindex="0"
                    [attr.aria-label]="billAccountOption.radioFieldErrorMessage"
                    class="pad-left-8"
                  >
                    {{ billAccountOption.radioFieldErrorMessage }}
                  </span>
                </div>
              }
            </div>
            <!-- Alert message -->
            @if (billAccountOption.alertMessage?.heading && checkBoxOption.at(i).value) {
              <div class="pad-bottom-16 margin-top-16">
                @if (!billAccountOption.alertMessage.error) {
                  <ds-warning-box
                    [headingText]="billAccountOption.alertMessage.heading"
                    [messageText]="billAccountOption.alertMessage.body1"
                    [linkText]="billAccountOption.alertMessage.body2Text"
                    (linkEvent)="linkEvent($event, billAccountOption.id)"
                    [postLinkText]="billAccountOption.alertMessage.body3"
                  ></ds-warning-box>
                }
                @if (billAccountOption.alertMessage.error) {
                  <ds-errorbox
                    [headingText]="billAccountOption.alertMessage.heading"
                    [messageText]="billAccountOption.alertMessage.body1"
                    [linkText]="billAccountOption.alertMessage.body2Text"
                    (linkEvent)="linkEvent($event, billAccountOption.id)"
                    [postLinkText]="billAccountOption.alertMessage.body3"
                  ></ds-errorbox>
                }
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>
}
